import { StateCreator, create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { Rol } from '../models/rol.model';

export type RolStoreSlice = {
  roles: Rol[];
  setRoles: (roles: Rol[]) => void;
};

export const DefaultRolStore = {
  roles: [],
};

const rolStateSlice: StateCreator<
  RolStoreSlice,
  [['zustand/devtools', never], ['zustand/persist', unknown]],
  [],
  RolStoreSlice
> = (set) => ({
  ...DefaultRolStore,
  setRoles: (roles: Rol[]) => set(() => ({ roles }), undefined, 'rol/setRoles'),
});

export const useRolStore = create<RolStoreSlice>()(
  devtools(persist(rolStateSlice, { name: 'rol' }), { name: 'rol' })
);
